<template>
  <el-table-column
    prop="price"
    sortable="custom"
    label="Nettó Ár"
    show-overflow-tooltip
    min-width="100px"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.price">{{ scope.row.price|currency }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'price',
  };
</script>
